import { render } from "./OrganizationNotFound.vue?vue&type=template&id=1b6ac850"
import script from "./OrganizationNotFound.vue?vue&type=script&lang=js"
export * from "./OrganizationNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__